import { Component, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'zx-tabs-block',
  templateUrl: './tabs-block.component.html',
  styleUrls: [ './tabs-block.component.css' ],
})
export class TabsBlockComponent {

  // tabs = [{ iconClass:"anticon anticon-shopping-cart", label:"模板标签1", template:tab1 }, { label:"文本内容标签2", content:"这是日志内容", routerLink: null }, { label:"点击跳转", routerLink:"/" }];
  @Input() tabs: any[]; 

  constructor(private route: ActivatedRoute, private router: Router) { }

  clickTab(tab): void {
    if(tab.routerLink){
      this.router.navigate([ tab.routerLink ], {relativeTo:this.route}); 
    }
  }
}